import React from 'react';
import VendorDocumentsList from './List/VendorDocumentsList';

const VendorDocuments = () => {
  return <VendorDocumentsList />;
};

export default VendorDocuments;
